"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DocumentType = void 0;

var _object = require("./object");

var DOCUMENT_CORE = {
  name: 'document',
  type: null,
  jsonType: 'object'
};
var DocumentType = {
  get() {
    return DOCUMENT_CORE;
  },

  extend: _object.ObjectType.extend
};
exports.DocumentType = DocumentType;